export default "### Bring your own financier\n\nAlready locked in finance elsewhere? No problem. We'll work with them to finance your car.\n";